/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateHarmfulFactorDto
 */
export interface CreateUpdateHarmfulFactorDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHarmfulFactorDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateHarmfulFactorDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHarmfulFactorDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateHarmfulFactorDto
     */
    category?: CreateUpdateHarmfulFactorDtoCategoryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateHarmfulFactorDto
     */
    testsIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateHarmfulFactorDto
     */
    supportingExaminationsIds?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateHarmfulFactorDto
     */
    yearsForJudgment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateHarmfulFactorDto
     */
    systemNumber?: number | null;
}


/**
 * @export
 */
export const CreateUpdateHarmfulFactorDtoCategoryEnum = {
    Biological: 'Biological',
    Chemical: 'Chemical',
    Physical: 'Physical',
    Other: 'Other',
    Learn: 'Learn'
} as const;
export type CreateUpdateHarmfulFactorDtoCategoryEnum = typeof CreateUpdateHarmfulFactorDtoCategoryEnum[keyof typeof CreateUpdateHarmfulFactorDtoCategoryEnum];


/**
 * Check if a given object implements the CreateUpdateHarmfulFactorDto interface.
 */
export function instanceOfCreateUpdateHarmfulFactorDto(value: object): value is CreateUpdateHarmfulFactorDto {
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CreateUpdateHarmfulFactorDtoFromJSON(json: any): CreateUpdateHarmfulFactorDto {
    return CreateUpdateHarmfulFactorDtoFromJSONTyped(json, false);
}

export function CreateUpdateHarmfulFactorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateHarmfulFactorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'],
        'description': json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'testsIds': json['testsIds'] == null ? undefined : json['testsIds'],
        'supportingExaminationsIds': json['supportingExaminationsIds'] == null ? undefined : json['supportingExaminationsIds'],
        'yearsForJudgment': json['yearsForJudgment'] == null ? undefined : json['yearsForJudgment'],
        'systemNumber': json['systemNumber'] == null ? undefined : json['systemNumber'],
    };
}

export function CreateUpdateHarmfulFactorDtoToJSON(value?: CreateUpdateHarmfulFactorDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'active': value['active'],
        'description': value['description'],
        'category': value['category'],
        'testsIds': value['testsIds'],
        'supportingExaminationsIds': value['supportingExaminationsIds'],
        'yearsForJudgment': value['yearsForJudgment'],
        'systemNumber': value['systemNumber'],
    };
}

